// extracted by mini-css-extract-plugin
export default {"root":"_11QCc"};